import { STYLE_CLASSES } from './styleClasses.constant';

export const styleClasses = Object.entries(STYLE_CLASSES).map(([key, value], index) => value);
